import { render, staticRenderFns } from "./transferResults.vue?vue&type=template&id=751237c4&scoped=true"
import script from "./transferResults.vue?vue&type=script&lang=js"
export * from "./transferResults.vue?vue&type=script&lang=js"
import style0 from "./transferResults.vue?vue&type=style&index=0&id=751237c4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "751237c4",
  null
  
)

export default component.exports